module.exports = __webpack_public_path__ + "static/media/6_armies.a78226ea.png";